import i18next from 'i18next'
import {useState} from 'react'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {setSoItem, soSelector} from 'src/redux/slices/soSlices'
import {updateSoItem} from 'src/services/mutations'
import swal from 'sweetalert'

export const useModalEditSO = () => {
  const dispatch = useAppDispatch()
  const {soItem, orderItem} = useAppSelector(soSelector)

  const [isLoading, setIsLoading] = useState(false)

  const onResetSoItem = () => dispatch(setSoItem(null))

  const onUpdate = async () => {
    if (!soItem && !orderItem) {
      throw new Error("soItem and orderItem can't be null")
    }

    try {
      setIsLoading(true)

      const res = await updateSoItem({
        id_soitem: orderItem?.id as number,
        plant: soItem?.plant as string,
        plant_desc: soItem?.plant_desc as string,
        price: soItem?.price as number,
        quantity: soItem?.quantity as string,
        route: soItem?.route as string,
        route_desc: soItem?.route_desc as string,
        sloc: soItem?.sloc as string,
        sloc_description: soItem?.sloc_description as string,
        lang: i18next.language,
        notes: soItem?.notes,
        product_spec: soItem?.product_spec,
        shipping_tolerance: soItem?.shipping_tolerance,
        incoterm1_id: soItem?.incoterm1,
        incoterm2_id: soItem?.incoterm2,
      })

      const {error, message} = res.data
      setIsLoading(false)

      if (error) {
        const title = message ?? 'Unexpected error'
        await swal({icon: 'error', title})
        return false
      }

      const title = message ?? 'Item updated'
      await swal({icon: 'success', title})
      // onResetSoItem()
      return true
    } catch (error: any) {
      setIsLoading(false)
      let errorMessage = 'Unexpected error'
      if(error?.response?.data){
        errorMessage = error?.response?.data?.message
      }else{
        errorMessage = error?.message
      }
      await swal({icon: 'error', title: errorMessage})
      return false
    }
  }

  return {
    /** loading state */
    isLoading,
    /** Handler for reseting the so item state */
    onResetSoItem,
    /** Handler for submitting the so item update */
    onUpdate,
  }
}
